import { airportConstants } from '../_constants';
import { airportService } from '../_services';
import { error as toastError} from 'react-toastify-redux';
import { history } from '../_helpers';

export const airportActions = {
    getAll,
    createNew,
    update,
    delete: _delete
  };


function getAll() {
    return dispatch => {

        dispatch(request());
        console.log("REQUESTED")
        airportService.getAll(1, 10, "")
            .then(
                airports => {
                    console.log("THEN SUCCESS");
                    dispatch(success(airports))
                }
            ).catch(
                error => {
                    console.log("THEN ERROR");
                    dispatch(failure(error.error));
                    //dispatch(toastError(error));
            });
    };

    function request() { return { type: airportConstants.GETALL_REQUEST } }
    function success(airports) { return { type: airportConstants.GETALL_SUCCESS, airports } }
    function failure(error) { return { type: airportConstants.GETALL_FAILURE, error } }
}

function createNew(airport)  {
    return dispatch => {
        dispatch(request(airport));

        airportService.create(airport)
            .then(
                airport => {
                    dispatch(success(airport));
                },
                error => {
                    dispatch(failure(error));
                    //dispatch(toastError(error));
                }
            );
    };

    function request(id) { return { type: airportConstants.CREATE_REQUEST, airport } }
    function success(id) { return { type: airportConstants.CREATE_SUCCESS, id } }
    function failure(id, error) { return { type: airportConstants.CREATE_FAILURE, id, error } }
}

function update(edit)  {
    return dispatch => {
        dispatch(request(edit));

        return airportService.update(edit)
            .then(
                airport => {
                    dispatch(success(airport));
                    return airport;
                },
                error => {
                    dispatch(failure(error));
                    //dispatch(toastError(error));
                    return error;
                }
            );
    };

    function request(id) { return { type: airportConstants.UPDATE_REQUEST, edit } }
    function success(id) { return { type: airportConstants.UPDATE_SUCCESS, edit } }
    function failure(id, error) { return { type: airportConstants.UPDATE_FAILURE, id, error } }
}

function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        airportService.delete(id)
            .then(
                user => {
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: airportConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: airportConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: airportConstants.DELETE_FAILURE, id, error } }
}
